import { render, staticRenderFns } from "./TabDetalle.vue?vue&type=template&id=210e30d9&"
import script from "./TabDetalle.vue?vue&type=script&lang=ts&"
export * from "./TabDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports